import {Repository} from "@api/repositories/Repository";
import {AxiosInstance} from "axios";

export class FavoriteRepository implements Repository {
    client: AxiosInstance;

    constructor(client: AxiosInstance) {
        this.client = client;
    }

    list(schemaId: string): Promise<string[]> {
        return this.client.get<string[]>(`/favorites/${schemaId}`)
            .then(({data}) => {
                return data;
            })
    }

    add(schemaId: string, objectId: string) {
        return this.client.post(`/favorites/${schemaId}/${objectId}`)
    }

    delete(schemaId: string, objectId: string) {
        return this.client.delete(`/favorites/${schemaId}/${objectId}`);
    }
}